import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import "amfe-flexible"

import './assets/main.css'

const app = createApp(App)
app.use(router).use(Vant)

router.isReady().then(() => app.mount('#app'))